import {setStore} from '../../../src/utility/setStore'
export default {
    SET_USER(state,data) {
        state.user = data;
        //setStore('moduleName','Key',value)
        setStore('admin','user',data)
    },
    SET_ALL_USERS(state,data) {
        state.users = data;
        //setStore('moduleName','Key',value)
        setStore('admin','users,list',data)
    },
    SET_MESSAGES(state,data) {
        state.messages = data;
        //setStore('moduleName','Key',value)
        setStore('admin','messages',data)
    },
    SET_LANGUAGES(state,data) {
        state.languages = data.data;
        //setStore('moduleName','Key',value)
        setStore('website','languages,list',data.data)
    },
};
